module.exports = __webpack_public_path__ + "img/biblioteca-municipal.d0923e58.jpg";